/**
 * Set max height of tippy tooltip based on reference element's position
 */
import { Instance } from 'tippy.js';

const DEFAULT_GAP = 8;

const setMaxHeight = (instance: Instance) => {
  requestAnimationFrame(() => {
    const parentHeight = document.body.clientHeight;

    const { height: referenceHeight, top: referenceTop } = (
      instance.props.content as HTMLElement
    ).getBoundingClientRect();

    // when reference top plus reference height is greater than parent height
    const overflowingY = referenceTop + referenceHeight > parentHeight;

    if (overflowingY) {
      // calculate max height based on reference top
      const maxHeight = parentHeight - referenceTop - DEFAULT_GAP;

      (instance.props as any).maxHeight = maxHeight;
      (instance.props.content as HTMLElement).style.maxHeight = `${maxHeight}px`;
    }
  });
};
export default setMaxHeight;
